<template>
  <div class="headbar" :style="{'background': themeColor}"
       :class="$store.state.app.collapse ? 'position-collapse-left' : 'position-left'">
    <!-- 导航收缩 -->
    <span class="hamburg">
      <el-menu class="el-menu-demo" :background-color="themeColor" text-color="#fff"
               :active-text-color="themeColor" mode="horizontal">
        <el-menu-item index="1" @click="onCollapse"><hamburger :isActive="collapse"></hamburger></el-menu-item>
      </el-menu>
    </span>
    <!-- 导航菜单 -->

    <!-- 工具栏 -->
    <span class="toolbar">
      <el-menu class="el-menu-demo barMenu" :background-color="themeColor" :text-color="themeColor"
               :active-text-color="themeColor" mode="horizontal">
        <el-menu-item style="color:#ffffff;margin-right:15px;" index="2" @click="openAiChat">
          AI 问答
        </el-menu-item>
        <a style="color:#ffffff;margin-right:15px;" href="http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/管理后台操作手册.ppt">操作手册</a>
        <a style="color:#ffffff;" href="http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/常见问题解决说明.doc">常见问题</a>
        <el-menu-item index="5" v-popover:popover-personal>
          <!-- 用户信息 -->
          <span class="user-info"><img :src="user.avatar" />{{user.name}}</span>
          <el-popover ref="popover-personal" placement="bottom-end" trigger="click" :visible-arrow="false">
            <personal-panel :user="user"></personal-panel>
          </el-popover>
        </el-menu-item>
      </el-menu>
    </span>
    <!-- AI 问答弹窗 -->
    <div v-if="aiChatVisible" class="ai-chat-dialog">
      <iframe class="ai-chat" name="ai_chat"
        :src="'https://nginx.weface.com.cn/appH5/appoutlink/#/AIChart?userId=' + userId + '&phone=18255476769&source=1'"
        width="100%" height="400" frameborder="0" marginwidth="0" marginheight="0" scrolling="auto">
      </iframe>
      <el-button class="ai-close-btn" type="danger" @click="aiChatVisible = false">关闭</el-button>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import mock from "@/mock/index"
import Hamburger from "@/components/Hamburger"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
import Action from "@/components/Toolbar/Action"
import NoticePanel from "@/views/Core/NoticePanel"
import MessagePanel from "@/views/Core/MessagePanel"
import PersonalPanel from "@/views/Core/PersonalPanel"
export default {
  components:{
        Hamburger,
        ThemePicker,
        LangSelector,
        Action,
        NoticePanel,
        MessagePanel,
        PersonalPanel
  },
  data() {
    return {
      user: {
        name: "",
        avatar: "",
        role: "",
        registeInfo: " "
      },
      activeIndex: '1',
      langVisible: false,
      aiChatVisible: false, // AI 问答弹窗状态
    }
  },
  methods: {
    openAiChat() {
      this.aiChatVisible = true; // 打开 AI 问答弹窗
    },
    openWindow(url) {
      window.open(url)
    },
    selectNavBar(key, keyPath) {
      console.log(key, keyPath)
    },
    // 折叠导航栏
    onCollapse: function() {
      this.$store.commit('onCollapse')
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    },
    // 语言切换
    changeLanguage(lang) {
      lang === '' ? 'zh_cn' : lang
      this.$i18n.locale = lang
      this.langVisible = false
    }
  },
  mounted() {
    this.sysName = ""
    var user = sessionStorage.getItem("user")
    if (user) {
      this.user.name = user
      this.user.avatar = require("@/assets/user.png")
    }
    setTimeout(() => {
       console.log(this.themeColor)
    }, 3000);
   
  },
  computed:{
    ...mapState({
      themeColor:state=>state.app.themeColor,
      collapse: state=>state.app.collapse
    }),
    userId() {
      // 从 cookie 中获取 token
      const getCookieValue = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

      const token = getCookieValue('token'); // 假设你的 token 在 cookie 中叫 'token'
      if (!token) return '99999'; // 默认值

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.userId || '99999';
      } catch (e) {
        return '99999'; // 解析失败返回默认值
      }
    }
  },
}
</script>

<style scoped lang="scss">
.headbar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1030;
  height: 60px;
  line-height: 60px;
  border-color: rgba(180, 190, 190, 0.8);
  border-left-width: 1px;
  border-left-style: solid;
  display: flex;
  justify-content: space-between
}
.hamburg, .navbar {
  float: left;
}

.toolbar {
  display: flex;
  float: right;
   ul{
     display: flex
   }
}
.lang-item {
  font-size: 16px;
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}
.lang-item:hover {
  font-size: 18px;
  background: #b0d6ce4d;
}
.user-info {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 10px 0px 10px 10px;
    float: right;
  }
}
.badge {
  line-height: 18px;
}
.position-left {
  left: 200px;
}
.position-collapse-left {
  left: 65px;
}
.weather{
  margin-right: 10vw;
  width: 500px;
  pointer-events: none;
}
/* 弹窗自定义样式 */
.ai-chat-dialog {
  position: fixed !important;
  bottom: 20px !important;   /* 距离底部20px */
  right: 20px !important;    /* 距离右边20px */
  width: 600px !important;
  height: 450px !important;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  background: #fff;
  z-index: 1050; /* 确保在最上层 */
}

/* 强制弹窗包裹层定位 */
::v-deep(.el-dialog__wrapper) {
  position: fixed !important; /* 强制固定定位 */
  bottom: 20px !important;    /* 距离底部20px */
  right: 20px !important;     /* 距离右边20px */
  margin: 0 !important;       /* 去掉任何默认的 margin */
  display: block !important;  /* 强制弹窗不居中 */
  z-index: 1050 !important;   /* 确保其层级高 */
}

/* 调整el-dialog的内容样式，确保位置正确 */
::v-deep(.el-dialog) {
  position: absolute !important; /* 防止默认居中 */
  bottom: 0 !important; /* 距离底部 */
  right: 0 !important;  /* 距离右边 */
  margin: 0 !important; /* 去掉默认的居中样式 */
  width: 100% !important; /* 确保宽度是100% */
  box-shadow: none !important; /* 去除阴影 */
}
.ai-close-btn {
  position: absolute;
  bottom: 5px;  /* 让按钮距离底部40px，之前是10px，可以根据需要调整 */
  left: 10px;    /* 保持按钮距离左侧10px */
}
</style>


// WEBPACK FOOTER //
// src/views/HeadBar/HeadBar.vue